import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { timeout } from "rxjs/operators";

declare function require(url: string);

const conf = require("assets/appconf.json");

@Injectable()
export class WsSpa {
  private spaUrl = conf.server.url;
  private headers = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.headers = this.headers.append(
      "Authorization",
      "Basic " + btoa("spa-painel:c2pyW2FnCrQ2")
    );
    this.headers = this.headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
  }

  public getFunction(funcao, parametro, server) {
    // console.log(this[server] + '/' + funcao + '/' + parametro);
    if (parametro === false) {
      return this.http
        .get(`${this[server]}/${funcao}`, { headers: this.headers })
        .pipe(timeout(6000000));
    } else {
      return this.http
        .get(`${this[server]}/${funcao}/${parametro}`, {
          headers: this.headers,
        })
        .pipe(timeout(6000000));
    }
  }

  public setFunction(funcao, objeto, server) {
    const url = `${this[server]}/${funcao}`;
    return this.http.post(url, JSON.stringify(objeto), {
      headers: this.headers,
    });
  }
}
